export default {"src":"/_next/static/media/back_circle_navigation.6c52758a.svg","height":52,"width":52};